import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { sv } from 'date-fns/locale';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './config/keycloak';
import { ThemeContextProvider } from './contexts/ThemeContext';
import App from './App';
import './i18n'; // Initialize i18n

const keycloakProviderInitConfig = {
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  checkLoginIframe: false,
  pkceMethod: 'S256',
  enableLogging: true,
};

const onKeycloakEvent = (event, error) => {
  console.log('Keycloak event:', event);
  
  if (error) {
    console.error('Keycloak error:', error);
  }
  
  // Set up automatic token refresh when ready
  if (event === 'onReady' && keycloak.authenticated) {
    console.log('Setting up token refresh...');
    // Refresh token every 5 minutes (300 seconds)
    setInterval(() => {
      keycloak.updateToken(70).then((refreshed) => {
        if (refreshed) {
          console.log('Token refreshed');
        }
      }).catch(() => {
        console.error('Failed to refresh token');
      });
    }, 300000); // 5 minutes
  }
  
  if (event === 'onTokenExpired') {
    console.log('Token expired, refreshing...');
    keycloak.updateToken(30).catch(() => {
      console.error('Failed to refresh expired token');
    });
  }
};

const onKeycloakTokens = (tokens) => {
  if (tokens.token) {
    console.log('Tokens updated');
  }
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <ReactKeycloakProvider 
    authClient={keycloak}
    initOptions={keycloakProviderInitConfig}
    onEvent={onKeycloakEvent}
    onTokens={onKeycloakTokens}
  >
    <BrowserRouter>
      <ThemeContextProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
          <App />
        </LocalizationProvider>
      </ThemeContextProvider>
    </BrowserRouter>
  </ReactKeycloakProvider>
);
